import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../store';
import { blobRequest, showPhotoViewer, stopShowPhotoViewer } from '../../store/photos/slice';
import { IPhotosState } from '../../store/photos/types';
import ArrowLeft from '../ArrowLeft';
import ArrowRight from '../ArrowRight';
import CloseButtonImage from '../CloseButtonImage';
import Loading from '../Loading';
import { Container, Content, Image } from './styles'

interface Props {
    src: string;
}
const PhotoViewer: React.FC<Props> = ({ src }) => {

    const blobPhoto = useSelector((state: IApplicationState) => state.photos.blobs[src]);

    const photosState = useSelector(
        (state: IApplicationState) => state.photos
    ) as IPhotosState

    const dispatch = useDispatch();

    const photoViewer = photosState.photoViewer

    useEffect(() => {
        if (!blobPhoto) {
            dispatch(blobRequest({
                link: src
            }))
        }
    }, [blobPhoto, dispatch, src])

    return <Container>
        <CloseButtonImage onClose={() => { dispatch(stopShowPhotoViewer()) }} />
        <Content>
            <ArrowLeft onLeft={() => {
                if (photoViewer) {
                    dispatch(showPhotoViewer({
                        ...photoViewer,
                        positionPhoto: photoViewer.positionPhoto > 0 ? photoViewer.positionPhoto - 1 : photoViewer?.arrayPhoto.length - 1
                    }))
                }
            }} />
            {blobPhoto && blobPhoto.isLoading && <Loading />}
            {blobPhoto && blobPhoto.blob && <Image src={URL.createObjectURL(blobPhoto.blob)} />}
            <ArrowRight onRight={() => {
                if (photoViewer) {
                    dispatch(showPhotoViewer({
                        ...photoViewer,
                        positionPhoto: photoViewer.positionPhoto < (photoViewer.arrayPhoto.length - 1) ? photoViewer.positionPhoto + 1 : 0
                    }))
                }
            }} />
        </Content>
    </Container>
}

export default PhotoViewer;